/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { makeStyles } from '@material-ui/core/styles';
import { push } from 'connected-react-router';
import Dialog from './dialog';
import get from 'lodash/get';
import GetAppIcon from '@material-ui/icons/GetApp';
import { EUROPE } from 'enums/regions';
import { DropzoneDialog } from 'material-ui-dropzone';
import { toast } from 'react-toastify';
import toastConfig from 'enums/toast';
import axios from 'axios';
import { useIntl } from 'react-intl';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;

const useStyles = makeStyles((theme) => ({
  icon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

const Actions = ({ push, value, row }) => {
  const classes = useStyles();
  const intl = useIntl();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleProvinceChange = (event, value) => {
    setSelectedProvince(value);
  };

  const isClient = get(row, 'data.status', '') === 'Cliente';
  const isClosed = row.isClosed;

  // const handleSave = async (files) => {
  //   if (files.length > 0) {
  //     const file = files[0];
  //     const newFileName = `end_user-${file.name}`;
  //     setFileName(file.name);

  //     const blob = new Blob([file], { type: file.type });
  //     const newFile = new File([blob], newFileName, { type: file.type });

  //     const data = new FormData();
  //     data.append('file', newFile);

  //     try {
  //       const url = `${API_URL}/bulk/upload`;
  //       const response = await axios.post(url, data, {
  //         headers: {
  //           Authorization: `Bearer ${window.localStorage.getItem(
  //             ACCESS_TOKEN,
  //           )}`,
  //         },
  //       });

  //       if (response.status === 200) {
  //         localStorage.setItem('endUserFileUrl', response.data.url);
  //         setOpen(false);
  //         toast.success(
  //           <FormattedMessage id="El archivo se envió correctamente" />,
  //         );
  //       } else {
  //         throw new Error('Error en la respuesta del servidor');
  //       }
  //     } catch (error) {
  //       console.error('Error al subir el archivo:', error);
  //       setOpen(false);
  //       toast.error(
  //         <FormattedMessage id="Hubo un error al enviar el archivo" />,
  //       );
  //     }
  //   }
  // };

  const { code } = row;

  const isAproved = row.isApproved;

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        &bull;&bull;&bull;
      </Button>

      {isClosed ? (
        <>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {!isAproved ? (
              <>
                <MenuItem
                  onClick={() => push(`/distributor/building/view/${value}`)}
                >
                  <VisibilityIcon className={classes.icon} />
                  <FormattedMessage id="Ver" />
                </MenuItem>

                {!Boolean(code) && (
                  <MenuItem
                    onClick={() =>
                      push(`/distributor/building/warranty/${value}`)
                    }
                  >
                    <AssignmentTurnedInIcon className={classes.icon} />
                    <FormattedMessage id="Otorgar certificado de garantia" />
                  </MenuItem>
                )}
              </>
            ) : (
              <>
                <MenuItem
                  onClick={() => push(`/distributor/building/view/${value}`)}
                >
                  <VisibilityIcon className={classes.icon} />
                  <FormattedMessage id="Ver" />
                </MenuItem>
                <MenuItem onClick={handleOpenDialog}>
                  <MailOutlineIcon className={classes.icon} />
                  <FormattedMessage id="Volver a enviar cert de garantía" />
                </MenuItem>
              </>
            )}
            {openDialog && (
              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                code={value}
              />
            )}
          </Menu>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default connect(undefined, { push })(Actions);
